import React from 'react';
import Loader from './Loader';
import c from 'classnames';

const noop = () => {};

interface Props {
    label: string;
    onChange?: (value: File[]) => void;
    accept?: string;
    busy?: boolean;
}

export default function FileInput({ label, onChange = noop, accept, busy = false }: Props) {
    return (
        <label
            className={c(
                'text-white text-sm p-2 font-semibold rounded shadow-lg hover:bg-blue-400 focus:ring-blue-500 cursor-pointer',
                { 'bg-blue-600': !busy, 'bg-blue-400': busy }
            )}
        >
            {busy && <Loader small />}
            {!busy && label}
            <input
                accept={accept}
                style={{ display: 'none' }}
                type="file"
                onChange={(e) => {
                    if (e.target.files) {
                        onChange(Array.from(e.target.files));
                        e.target.value = ''; //clear the input
                    }
                }}
                disabled={busy}
            />
        </label>
    );
}
